import * as React from "react"

export default function DownloadCloudOutlineIcon(props) {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.833 17.484a5.417 5.417 0 01-2.447-10 6.668 6.668 0 0113.227 0 5.416 5.416 0 01-2.447 10v.016H5.833v-.016zm5-7.484V6.667H9.166V10h-2.5L10 14.167 13.333 10h-2.5z"
        fill={props.fill}
      />
    </svg>
  )
} 
